import { footer, site } from '@/content/site';
import { triggerCookieSettings } from '@/components/CookieBanner';
import { trackWhatsAppSalesClick } from '@/lib/tracking';
import { LogoMark } from './Icons';
import './Footer.css';

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container site-footer__inner">
        <div className="site-footer__brand">
          <LogoMark />
          <div>
            <strong>{site.brand}</strong>
            <p>{footer.tagline}</p>
          </div>
        </div>
        <nav className="site-footer__nav" aria-label="Pie">
          {footer.legal.map((link) =>
            'action' in link && link.action === 'cookie-settings' ? (
              <button
                key={link.label}
                type="button"
                className="site-footer__link-btn"
                onClick={() => triggerCookieSettings()}
              >
                {link.label}
              </button>
            ) : (
              <a
                key={link.label}
                href={link.href}
                {...('external' in link && link.external
                  ? { target: '_blank', rel: 'noopener noreferrer' }
                  : {})}
                onClick={() => {
                  if ('external' in link && link.external) {
                    trackWhatsAppSalesClick('footer', link.label, link.href);
                  }
                }}
              >
                {link.label}
              </a>
            ),
          )}
        </nav>
        <p className="site-footer__copy">
          © {year} {site.brand} · {site.domain}
        </p>
      </div>
    </footer>
  );
}
